import { PayItemsOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useConcreteTestSetTrackerContext } from '../ConcreteTestSetTrackerContext'
import { ConcreteTestSet } from '../ConcreteTestSetTrackerContext/types'

export function usePayItems(): PayItemsOptions<ConcreteTestSet> {
  const { payItemGlobalId } = useConcreteTestSetTrackerContext()
  return {
    globalId: payItemGlobalId,
    hidden: !!payItemGlobalId,
    onFilter: (
      payItemGlobalId,
      { payItemNoGeometries, concreteTests, concretePlacements }
    ) =>
      payItemNoGeometries.some(
        ({ globalId }) => globalId === payItemGlobalId
      ) ||
      concreteTests.some(({ payItemNoGeometries }) =>
        payItemNoGeometries.some(({ globalId }) => globalId === payItemGlobalId)
      ) ||
      concretePlacements.some(({ payItemNoGeometries }) =>
        payItemNoGeometries.some(({ globalId }) => globalId === payItemGlobalId)
      ),
  }
}
